import DataDisplayRowI from "../DataDisplayRowI";
import getGPURow from "../DataDisplayRow/GPURow";
import DataDisplayTable from "../DataDisplayTable";

class GPUTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getGPURow()
    }
}

let gpuTable: GPUTable | null = null;

export default function getGPUTable(): GPUTable {
    if (gpuTable === null)
        gpuTable = new GPUTable()
    return gpuTable
}